/*
  Xhale PDP boost — a terméklap vásárlás-orientált rétege.
  Jelölés + adat: snippets/xhale-pdp-boost.liquid · stílus: assets/xhale-pdp-boost.css

  CSAPDÁK, MINDBE BELEFUTOTTUNK — NE ÁLLÍTSD VISSZA:
  1. A blokkokat ÁTHELYEZZÜK a #xpdp-ből. Utána a root már nem találja a saját
     gyerekeit, ezért minden hivatkozást ELŐRE elkapunk (el.*).
  2. Dawn variánsváltáskor újrarendereli a <variant-selects> belsejét → a
     választó MELLÉ kerül, nem bele.
  3. A MutationObserver a saját írásunkra is felébred (mérve: 450 újrarajzolás /
     2 mp). Ezért ujjlenyomat (lastSig), és minden DOM-írás előtt összehasonlítás.
  4. Többopciós terméknél (Vap-bar combo) a saját rács csak az első opciót fedné
     le → ilyenkor kimaradunk, Dawn választói maradnak.
  5. A puffszám kétféleképp áll a címben: "(33000 slukk)" és "80K".
  6. Többopciós terméknél a variánsszám PÁROSÍTÁS, nem íz.
  7. A kosárba gomb ELSŐ <span>-ja Dawné: ő írja át "Elfogyott"-ra. Nem nyúlunk
     hozzá — engedélyezett gombnál CSS-sel elrejtjük és mellé tesszük a sajátunkat.
  8. Előrendelős terméknél (pre-order kollekció) TILOS szállítási napot ígérni.
  10. A régi legördülőt NEM inline stílussal rejtjük: Dawn újrarendereli a
     variant-selects-et (pl. a korhatár-kapu után), és a stílus elveszett — mérve
     visszajött a legördülő. A <html> osztálya ezt túléli.
  11. A több-ízes (VapSolo) variánsa ÍZSZETT (4 íz/szett), nem egy íz.
  12. "Tedd mellé": a kártya a termék ELSŐ elérhető variánsát teszi kosárba, és ezt
     ki is írja. A kosár ikont a Dawn cart-icon-bubble szekciójával frissítjük, és
     publish(cartUpdate)-tel szólunk a témának — különben a fejléc számlálója áll.
     Az adat-<script> osztálya xpdp-xs-DATA: ha ugyanaz, mint a kártyadobozé
     (.xpdp-xs{display:grid}), a nyers JSON kiíródik a lap tetejére. Mérve.
  13. A mennyiség-választót a kosárba gomb MELLÉ tesszük (.product-form__buttons).
     Az input form= attribútummal kötődik az űrlaphoz, Dawn pedig csak a belsejét
     rendereli újra — az áthelyezés ezért biztonságos. Mérve: a kosárba tétel mennyisége
     átmegy.
  14. Az ízrácsban az elérhető ízek elöl, az elfogyottak a végén: a gomb így
     feljebb kerül, és a vevő nem áthúzott kártyákon kezdi.
  15. Az ízcsempe kattintáskor mindig FRISSEN kérdezi le a <select>-et (sel()): Dawn
     variánsváltáskor lecseréli az elemet, a bezárt régi referencia halott.
  9. Hamis számot nem írunk ki: se vásárlószámot, se kitalált áthúzott árat. A
     kedvezmény-matrica csak valódi compare_at_price esetén jelenik meg.
*/
(function () {
  var root = document.getElementById('xpdp');
  if (!root) return;

  var el = {};
  ['badges', 'benefits', 'picker', 'grid', 'chosen', 'tiles', 'ship', 'shipMsg', 'shipBar',
   'assure', 'sticky', 'stickyBtn', 'stickyPr', 'imgBadge', 'xs', 'xsHead', 'steps'].forEach(function (k) {
    el[k] = root.querySelector('[data-x="' + k + '"]');
  });

  var L = root.dataset.locale || 'en';
  var F = {
    best: root.dataset.best === 'true', pre: root.dataset.pre === 'true',
    rech: root.dataset.rech === 'true', multi: root.dataset.multi === 'true',
    avail: root.dataset.avail === 'true'
  };
  var nOpts = parseInt(root.dataset.options, 10) || 1;
  var FREE = 5000; // cent — a szállítási profilban: 50 € felett ingyenes

  var S = {
    hu: { best:'Bestseller', pre:'Előrendelés', rech:'Újratölthető', multi:'4 íz egy eszközben', stock:'Raktáron',
          cFlav:'{n} íz közül', cCombo:'{n} párosítás', cSets:'{n} ízszett közül', cPuffs:'{p} slukk', cShip:'2–5 nap, EU raktárból', cPre:'Előrendelhető', cSeal:'Gyári zárás',
          tPuffs:['{p}','slukk'], tFlav:['{n} íz','választható'], tCombo:['{n}','párosítás'], tSets:['{n} ízszett','választható'], tRech:['Type-C','újratölthető'],
          tMulti:['4 tartály','egy eszközben'], tShip:['2–5 nap','EU raktárból'], tPre:['Előrendelés','foglald le most'],
          stepsT:'Így rendelsz', s1:['Válaszd ki az ízt','A fenti választóból, egy kattintással.'], s2:['Tedd kosárba, add le','Utánvéttel előre nem kell fizetned.'], s3:['Fizess átvételkor','A futárnál vagy a Packeta-ponton.'], add:'Kosárba', xsAdd:'+ Kosárba', xsAdded:'✓ Kosárban', xsErr:'Hiba, próbáld újra', out:'Elfogyott', approx:'kb. {v}', rateNote:'Tájékoztató átváltás, EKB-árfolyam: 1 € = {r} Ft ({d}). A futárnak forintban fizetsz.',
          needThis:'Ezzel a termékkel még {x} hiányzik az ingyenes szállításhoz', needCart:'A kosaradhoz még {x} kell az ingyenes szállításhoz',
          doneThis:'Ezzel a termékkel ingyenes a szállítás', doneCart:'A kosaraddal ingyenes a szállítás', off:'-{p}%' },
    sk: { best:'Bestseller', pre:'Predobjednávka', rech:'Nabíjateľná', multi:'4 príchute v jednom', stock:'Skladom',
          cFlav:'{n} príchutí', cCombo:'{n} kombinácií', cSets:'{n} sád príchutí', cPuffs:'{p} potiahnutí', cShip:'2–5 dní z EU skladu', cPre:'Na predobjednávku', cSeal:'Továrenská pečať',
          tPuffs:['{p}','potiahnutí'], tFlav:['{n} príchutí','na výber'], tCombo:['{n}','kombinácií'], tSets:['{n} sád','na výber'], tRech:['Type-C','nabíjateľná'],
          tMulti:['4 nádržky','v jednom'], tShip:['2–5 dní','z EU skladu'], tPre:['Predobjednávka','rezervujte si'],
          stepsT:'Takto objednáte', s1:['Vyberte príchuť','Vo výbere vyššie, jedným klikom.'], s2:['Pridajte do košíka','Na dobierku vopred neplatíte.'], s3:['Zaplaťte pri prevzatí','Kuriérovi alebo na výdajnom mieste Packeta.'], add:'Do košíka', xsAdd:'+ Do košíka', xsAdded:'✓ V košíku', xsErr:'Chyba, skúste znova', out:'Vypredané', approx:'cca {v}', rateNote:'',
          needThis:'S týmto produktom chýba do dopravy zadarmo ešte {x}', needCart:'Do dopravy zadarmo vám v košíku chýba ešte {x}',
          doneThis:'S týmto produktom máte dopravu zadarmo', doneCart:'S vaším košíkom máte dopravu zadarmo', off:'-{p} %' },
    cs: { best:'Bestseller', pre:'Předobjednávka', rech:'Nabíjecí', multi:'4 příchutě v jednom', stock:'Skladem',
          cFlav:'{n} příchutí', cCombo:'{n} kombinací', cSets:'{n} sad příchutí', cPuffs:'{p} potáhnutí', cShip:'2–5 dní z EU skladu', cPre:'Na předobjednávku', cSeal:'Tovární pečeť',
          tPuffs:['{p}','potáhnutí'], tFlav:['{n} příchutí','na výběr'], tCombo:['{n}','kombinací'], tSets:['{n} sad','na výběr'], tRech:['Type-C','nabíjecí'],
          tMulti:['4 nádržky','v jednom'], tShip:['2–5 dní','z EU skladu'], tPre:['Předobjednávka','rezervujte si'],
          stepsT:'Takhle objednáte', s1:['Vyberte příchuť','Ve výběru výše, jedním kliknutím.'], s2:['Přidejte do košíku','Na dobírku předem neplatíte.'], s3:['Zaplaťte při převzetí','Kurýrovi nebo na výdejním místě Packeta.'], add:'Do košíku', xsAdd:'+ Do košíku', xsAdded:'✓ V košíku', xsErr:'Chyba, zkuste znovu', out:'Vyprodáno', approx:'cca {v}', rateNote:'Orientační přepočet, kurz ECB: 1 € = {r} Kč ({d}). Kurýrovi platíte v korunách.',
          needThis:'S tímto produktem chybí do dopravy zdarma ještě {x}', needCart:'Do dopravy zdarma vám v košíku chybí ještě {x}',
          doneThis:'S tímto produktem máte dopravu zdarma', doneCart:'S vaším košíkem máte dopravu zdarma', off:'-{p} %' },
    de: { best:'Bestseller', pre:'Vorbestellung', rech:'Wiederaufladbar', multi:'4 Sorten in einem', stock:'Auf Lager',
          cFlav:'{n} Sorten', cCombo:'{n} Kombinationen', cSets:'{n} Sorten-Sets', cPuffs:'{p} Züge', cShip:'2–5 Tage aus dem EU-Lager', cPre:'Vorbestellbar', cSeal:'Original versiegelt',
          tPuffs:['{p}','Züge'], tFlav:['{n} Sorten','zur Auswahl'], tCombo:['{n}','Kombinationen'], tSets:['{n} Sets','zur Auswahl'], tRech:['USB-C','wiederaufladbar'],
          tMulti:['4 Tanks','in einem Gerät'], tShip:['2–5 Tage','EU-Lager'], tPre:['Vorbestellung','jetzt reservieren'],
          stepsT:'So bestellst du', s1:['Sorte wählen','Oben in der Auswahl, mit einem Klick.'], s2:['In den Warenkorb und bestellen','Per Nachnahme zahlst du nichts im Voraus.'], s3:['Bei Lieferung bezahlen','Beim Kurier oder an der Packeta-Abholstelle.'], add:'In den Warenkorb', xsAdd:'+ Hinzufügen', xsAdded:'✓ Im Warenkorb', xsErr:'Fehler, bitte erneut versuchen', out:'Ausverkauft', approx:'ca. {v}', rateNote:'',
          needThis:'Mit diesem Artikel fehlen dir noch {x} bis zum kostenlosen Versand', needCart:'Deinem Warenkorb fehlen noch {x} bis zum kostenlosen Versand',
          doneThis:'Mit diesem Artikel ist der Versand kostenlos', doneCart:'Dein Warenkorb wird kostenlos versendet', off:'-{p} %' },
    en: { best:'Bestseller', pre:'Pre-order', rech:'Rechargeable', multi:'4 flavours in one', stock:'In stock',
          cFlav:'{n} flavours', cCombo:'{n} pairings', cSets:'{n} flavour sets', cPuffs:'{p} puffs', cShip:'2–5 days, EU warehouse', cPre:'Available to pre-order', cSeal:'Factory sealed',
          tPuffs:['{p}','puffs'], tFlav:['{n}','flavours'], tCombo:['{n}','pairings'], tSets:['{n} sets','to choose from'], tRech:['Type-C','rechargeable'],
          tMulti:['4 tanks','in one device'], tShip:['2–5 days','EU warehouse'], tPre:['Pre-order','reserve yours'],
          stepsT:'How ordering works', s1:['Pick your flavour','In the selector above, one click.'], s2:['Add to cart and order','With cash on delivery you pay nothing upfront.'], s3:['Pay on delivery','To the courier or at the Packeta point.'], add:'Add to cart', xsAdd:'+ Add', xsAdded:'✓ Added', xsErr:'Error, try again', out:'Sold out', approx:'approx. {v}', rateNote:'',
          needThis:'With this item you are {x} away from free shipping', needCart:'Your cart is {x} away from free shipping',
          doneThis:'This item gets you free shipping', doneCart:'Your cart ships free', off:'-{p}%' }
  };
  var T = S[L] || S.en;

  // NAPI ÁRFOLYAM (2026-09-21 óta). Az Európai Központi Bank referencia-árfolyama a
  // frankfurter.dev-ről (ingyenes, kulcs nélküli, CORS: *). Böngészőnként naponta
  // EGYSZER kérjük le, és a localStorage-ban tartjuk. Ha a lekérés elbukik, a lenti
  // tartalék marad — az az utolsó ISMERT EKB-érték, nem kitalált szám.
  //
  // KEREKÍTÉS: forint a legközelebbi 10 Ft-ra, korona 1 Kč-ra, Math.round-dal.
  // A korábbi változat felfelé kerekített 100 Ft-ra egy túlzó (370) árfolyamon:
  // 37,99 €-nál ez kb. 260 Ft-tal többet mutatott, mint a valóság.
  // A futár a saját árfolyamán szed, ez tájékoztató — ezt a buborék ki is írja.
  var FX_DEF = { hu: { code: 'HUF', rate: 364.28, step: 10, suffix: ' Ft', date: '2026-09-18' },
                 cs: { code: 'CZK', rate: 24.339, step: 1,  suffix: ' Kč', date: '2026-09-18' } };
  var XRATE = FX_DEF[L] || null;
  (function loadFx() {
    if (!XRATE) return;
    var KEY = 'xfx_v1', today = new Date().toISOString().slice(0, 10), cached = null;
    try { cached = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    function apply(c) {
      if (c && c.rates && c.rates[XRATE.code] > 0) {
        XRATE.rate = c.rates[XRATE.code];
        if (c.date) XRATE.date = c.date;
      }
    }
    apply(cached);
    if (cached && cached.checked === today) return;
    fetch('https://api.frankfurter.dev/v1/latest?base=EUR&symbols=HUF,CZK')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        var c = { rates: d.rates, date: d.date, checked: today };
        try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
        apply(c);
        paintPrice();   // függvény-deklaráció, fel van emelve — itt már létezik
      })
      .catch(function () {});
  })();

  function fxNote() {
    if (!XRATE || !T.rateNote) return '';
    var r = XRATE.rate.toLocaleString(L, { maximumFractionDigits: 3 });
    var d = new Date(XRATE.date + 'T12:00:00').toLocaleDateString(L);
    return T.rateNote.replace('{r}', r).replace('{d}', d);
  }

  var variants = [];
  try { variants = JSON.parse(root.querySelector('.xpdp-json').textContent).variants || []; } catch (e) {}

  function fill(s, o) { return s.replace('{n}', o.n).replace('{p}', o.p).replace('{x}', o.x).replace('{v}', o.v); }
  function setText(node, t) { if (node && node.textContent !== t) node.textContent = t; }  // 3. csapda
  function loc() { return L === 'en' ? 'en-GB' : L; }

  /* ---------- tények ---------- */
  var nAvail = variants.filter(function (v) { return v.available; }).length;
  var puffs = (function () {
    // 5. csapda
    var t = (root.dataset.title || '').replace(/(\d)[\s ](?=\d)/g, '$1'), best = 0;
    var mK = t.match(/(\d+(?:[.,]\d+)?)\s*[kK](?![a-zá-ž])/);
    if (mK) best = Math.round(parseFloat(mK[1].replace(',', '.')) * 1000);
    var nums = t.match(/\d{3,}/g);
    if (nums) best = Math.max(best, Math.max.apply(null, nums.map(Number)));
    return best >= 1000 ? best.toLocaleString(loc()) : null;
  })();
  var combo = nOpts > 1; // 6. csapda

  /* ---------- jelvények, csempék, kártyák (egyszer épülnek) ---------- */
  function badge(txt, kind) {
    var s = document.createElement('span');
    s.className = 'xpdp-badge xpdp-badge--' + kind;
    s.textContent = txt;
    return s;
  }
  if (F.best) el.badges.appendChild(badge(T.best, 'best'));
  if (F.pre) el.badges.appendChild(badge(T.pre, 'pre'));
  else if (F.avail) el.badges.appendChild(badge(T.stock, 'stock'));
  if (F.rech) el.badges.appendChild(badge(T.rech, 'plain'));
  if (F.multi && !combo) el.badges.appendChild(badge(T.multi, 'plain'));
  if (F.best) setText(el.imgBadge, T.best); else if (F.pre) setText(el.imgBadge, T.pre);
  if (!el.imgBadge.textContent) { el.imgBadge.remove(); el.imgBadge = null; }  // különben a place() üresen visszatenné
  if (el.imgBadge && F.pre && !F.best) el.imgBadge.classList.add('is-pre');

  var chips = [];
  if (puffs) chips.push(fill(T.cPuffs, { p: puffs }));
  // 11. csapda: a több-ízes (VapSolo) variánsa ÍZSZETT, nem egy íz — "10 íz" hazugság lenne.
  var sets = F.multi && !combo;
  if (nAvail > 1) chips.push(fill(combo ? T.cCombo : (sets ? T.cSets : T.cFlav), { n: nAvail }));
  chips.push(F.pre ? T.cPre : T.cShip);   // 8. csapda
  chips.push(T.cSeal);
  chips.slice(0, 4).forEach(function (c) {
    var li = document.createElement('li');
    li.textContent = c;
    el.benefits.appendChild(li);
  });

  var tiles = [];
  if (puffs) tiles.push([fill(T.tPuffs[0], { p: puffs }), T.tPuffs[1], 'puff']);
  if (nAvail > 1) tiles.push(combo ? [fill(T.tCombo[0], { n: nAvail }), T.tCombo[1], 'flav']
                         : sets  ? [fill(T.tSets[0], { n: nAvail }), T.tSets[1], 'flav']
                                 : [fill(T.tFlav[0], { n: nAvail }), T.tFlav[1], 'flav']);
  if (F.multi && !combo) tiles.push([T.tMulti[0], T.tMulti[1], 'multi']);
  else if (F.rech) tiles.push([T.tRech[0], T.tRech[1], 'bolt']);
  tiles.push(F.pre ? [T.tPre[0], T.tPre[1], 'cal'] : [T.tShip[0], T.tShip[1], 'truck']);
  var ICON = {
    puff: 'M6.5 17a4.5 4.5 0 0 1-.6-8.96A6 6 0 0 1 17.6 8.5 4.25 4.25 0 0 1 17.25 17H6.5Z',
    flav: 'M12 2.5s6 6.3 6 11a6 6 0 0 1-12 0c0-4.7 6-11 6-11Zm-2.6 11.2A2.6 2.6 0 0 0 12 16.3v-1.6a1 1 0 0 1-1-1H9.4Z',
    multi: 'M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z',
    bolt: 'M13 2 4.5 13.5H11L10 22l8.5-11.5H12L13 2Z',
    truck: 'M2 6h12v9H2V6Zm13 3h3.6L22 12.4V15h-7V9ZM6 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11.5 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
    cal: 'M7 2v2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7Zm-2 8h14v9H5v-9Z'
  };
  tiles.slice(0, 4).forEach(function (t) {
    var d = document.createElement('div');
    d.className = 'xpdp-tile';
    d.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + ICON[t[2]] + '"/></svg>' +
                  '<b></b><span></span>';
    d.querySelector('b').textContent = t[0];
    d.querySelector('span').textContent = t[1];
    el.tiles.appendChild(d);
  });
  el.tiles.style.setProperty('--n', Math.min(tiles.length, 4));

  /* ---------- "Így rendelsz" panel ---------- */
  var desk = window.matchMedia('(min-width: 750px)');
  el.steps = document.createElement('div');
  el.steps.className = 'xpdp-steps';
  el.steps.innerHTML = '<div class="xpdp-steps-t"></div><ol></ol>';
  el.steps.querySelector('.xpdp-steps-t').textContent = T.stepsT;
  [T.s1, T.s2, T.s3].forEach(function (st, i) {
    var li = document.createElement('li');
    li.innerHTML = '<span class="xpdp-steps-n"></span><div><b></b><span></span></div>';
    li.querySelector('.xpdp-steps-n').textContent = String(i + 1);
    li.querySelector('b').textContent = st[0];
    li.querySelector('div span').textContent = st[1];
    el.steps.querySelector('ol').appendChild(li);
  });
  if (desk.addEventListener) desk.addEventListener('change', function () { place(); });

  /* ---------- a lap fogódzkodói ---------- */
  function allSel()  { return document.querySelectorAll('variant-selects select.select__select'); }
  function sel()     { return allSel()[0] || null; }
  function realAtc() { return document.querySelector('.product-form__submit'); }
  function singleOption() { return nOpts === 1 && allSel().length === 1; } // 4. csapda

  function before(node, ref) {
    if (node && ref && ref.parentNode && node.nextElementSibling !== ref) ref.parentNode.insertBefore(node, ref);
  }
  function after(node, ref) {
    if (node && ref && ref.parentNode && node.previousElementSibling !== ref) ref.parentNode.insertBefore(node, ref.nextSibling);
  }

  function place() {
    var form = document.querySelector('.product-form__buttons');
    var title = document.querySelector('.product__info-container .product__title');
    if (!form || !title) return false;

    before(el.badges, title);

    var vs = document.querySelector('variant-selects');
    if (vs) before(el.picker, vs);                 // 2. csapda

    // Előnycsempék közvetlenül az ár (és az adó-sor) alá, a választó elé.
    var tax = document.querySelector('.product__info-container .product__tax');
    var priceBox = document.querySelector('.product__info-container [id^="price-"]');
    after(el.benefits, tax || priceBox);

    after(el.ship, form);

    // 13. csapda: mennyiség a kosárba gomb mellé, egy sorba.
    var qty = document.querySelector('.product__info-container .product-form__quantity');
    if (qty && qty.parentNode !== form) form.insertBefore(qty, form.firstChild);

    // A tulaj saját szállítás/fizetés doboza a szállítási sáv alá kerül — ha
    // nincs ilyen doboz, a saját tartalék sorunk megy a helyére.
    var trust = document.querySelector('.product__info-container .xhale-trust');
    if (trust) { after(trust, el.ship); if (el.assure.parentNode) el.assure.remove(); }
    else after(el.assure, el.ship);

    // Galéria: ikonos kártyák a képek alá, jelvény a főképre.
    var gal = document.querySelector('.product__media-wrapper media-gallery');
    if (gal) {
      if (el.tiles.parentNode !== gal) gal.appendChild(el.tiles);
      if (el.imgBadge && el.imgBadge.parentNode !== gal) gal.insertBefore(el.imgBadge, gal.firstChild);
    }

    // "Így rendelsz": desktopon a galéria alá (ott üres tér volt), mobilon a bizalmi doboz után.
    if (el.steps) {
      if (desk.matches && gal) { if (el.steps.parentNode !== gal) gal.appendChild(el.steps); }
      else { var anchor = trust || el.assure; if (anchor && anchor.parentNode) after(el.steps, anchor); }
    }

    if (root.hidden) root.hidden = false;
    return true;
  }

  /* ---------- ízválasztó ---------- */
  var lastSig = null;
  function renderGrid() {
    var s = sel();
    if (!s || s.options.length < 2 || !singleOption()) {
      if (!el.picker.hidden) el.picker.hidden = true;
      document.documentElement.classList.remove('xpdp-grid-on');
      return;
    }
    if (el.picker.hidden) el.picker.hidden = false;

    var sig = Array.prototype.map.call(s.options, function (o) { return o.value + '|' + (o.disabled ? 1 : 0); }).join('~');
    document.documentElement.classList.add('xpdp-grid-on');   // 10. csapda
    if (sig === lastSig) { sync(); return; }        // 3. csapda
    lastSig = sig;

    var withImg = variants.filter(function (v) { return v.img; }).length;
    var useImg = variants.length > 0 && withImg >= Math.ceil(variants.length * 0.6);
    el.grid.className = 'xpdp-grid ' + (useImg ? 'is-img' : 'is-text');
    el.grid.textContent = '';
    // 14. csapda: elérhető ízek elöl, elfogyottak a végén (a sorrend egyébként megmarad).
    var outOf = function (o) {
      var v = variants.filter(function (x) { return x.title === o.value; })[0];
      return v ? !v.available : /nincs készleten|vypredan|vyprodán|sold out/i.test(o.textContent);
    };
    var opts = Array.prototype.slice.call(s.options);
    opts = opts.filter(function (o) { return !outOf(o); }).concat(opts.filter(outOf));
    opts.forEach(function (o) {
      var v = variants.filter(function (x) { return x.title === o.value; })[0];
      var out = outOf(o);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'xpdp-opt' + (out ? ' is-out' : '');
      b.dataset.value = o.value;
      b.setAttribute('aria-pressed', String(o.value === s.value));
      if (out) { b.disabled = true; b.title = T.out; }
      if (useImg && v && v.img) {
        var im = document.createElement('img');
        im.src = v.img; im.alt = o.value; im.loading = 'lazy'; im.width = 120; im.height = 120;
        b.appendChild(im);
      }
      var nm = document.createElement('span');
      nm.className = 'xpdp-opt-name';
      nm.textContent = o.value;
      b.appendChild(nm);
      b.addEventListener('click', function () {
        if (out) return;
        // 15. csapda: MINDIG friss <select>-et kérünk. Dawn az első váltáskor kicseréli,
        // és a régire mutató kattintás csendben semmit nem csinál (mérve: a 2. váltás elveszett).
        var cur = sel();
        if (!cur || cur.value === o.value) { sync(); return; }
        cur.value = o.value;
        cur.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      el.grid.appendChild(b);
    });
    sync();
  }

  function sync() {
    var s = sel();
    if (!s) return;
    Array.prototype.forEach.call(el.grid.children, function (b) {
      var on = String(b.dataset.value === s.value);
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
    setText(el.chosen, s.value || '');
  }

  /* ---------- ár, forint, kosárba gomb ---------- */
  function priceNode() {
    return document.querySelector('.product__info-container .price__container .price-item--sale')
        || document.querySelector('.product__info-container .price__container .price-item--regular');
  }
  function parseEur(txt) {
    var m = (txt || '').replace(/[\s ]/g, '').match(/([\d.,]+)/);
    if (!m) return null;
    var raw = m[1], cut = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
    var n = (cut > -1 && raw.length - cut - 1 === 2)
      ? parseFloat(raw.slice(0, cut).replace(/[.,]/g, '') + '.' + raw.slice(cut + 1))
      : parseFloat(raw.replace(/[.,]/g, ''));
    return isFinite(n) ? n : null;
  }
  // A bolt saját pénzformátuma (€37,99 / en: €37.99) — egyezzen a Dawn-árral és a katalógussal.
  function eurFmt(cents) {
    var v = (cents / 100).toFixed(2);
    return '€' + (L === 'en' ? v : v.replace('.', ','));
  }
  function localAmount(eur) {
    if (!XRATE || eur == null) return null;
    return (Math.round(eur * XRATE.rate / XRATE.step) * XRATE.step).toLocaleString(L) + XRATE.suffix;
  }

  var curEur = null;
  function paintPrice() {
    var p = priceNode();
    if (!p) return;
    var eurTxt = p.textContent.trim().replace(/\s*EUR$/, '');
    curEur = parseEur(eurTxt);
    var box = p.closest('.price');

    if (XRATE && box) {
      var alt = box.querySelector('.xpdp-alt');
      var amt = localAmount(curEur);
      if (amt) {
        if (!alt) { alt = document.createElement('span'); alt.className = 'xpdp-alt'; box.appendChild(alt); }
        setText(alt, fill(T.approx, { v: amt }));
        var note = fxNote();
        if (note && alt.title !== note) alt.title = note;
      } else if (alt) alt.remove();
    }

    // 9. csapda: kedvezmény-matrica CSAK valódi compare_at_price esetén.
    if (box) {
      var reg = box.querySelector('.price__sale s .price-item--regular, .price__sale .price-item--regular');
      var off = box.querySelector('.xpdp-off');
      var was = box.classList.contains('price--on-sale') && reg ? parseEur(reg.textContent) : null;
      var pct = (was && curEur && was > curEur) ? Math.round((1 - curEur / was) * 100) : 0;
      if (pct >= 1) {
        if (!off) { off = document.createElement('span'); off.className = 'xpdp-off'; box.appendChild(off); }
        setText(off, fill(T.off, { p: pct }));
      } else if (off) off.remove();
    }

    // 7. csapda: Dawn első span-ját nem írjuk, csak mellé teszünk sajátot.
    var a = realAtc();
    if (a) {
      var lab = a.querySelector('.xpdp-atc');
      if (!lab) { lab = document.createElement('span'); lab.className = 'xpdp-atc'; a.appendChild(lab); }
      setText(lab, T.add + ' · ' + eurTxt);
    }

    var amt2 = XRATE ? localAmount(curEur) : null;
    setText(el.stickyPr, amt2 ? eurTxt + ' · ' + amt2 : eurTxt);
    paintShip();
  }

  /* ---------- ingyenes szállítás sáv ---------- */
  var cartCents = null;
  function refreshCart() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCents = c.total_price || 0; paintShip(); })
      .catch(function () {});
  }
  function paintShip() {
    if (!el.ship || curEur == null) return;
    var inCart = cartCents && cartCents > 0;
    var projected = inCart ? cartCents : Math.round(curEur * 100);
    var left = FREE - projected;
    var msg = left > 0
      ? fill(inCart ? T.needCart : T.needThis, { x: eurFmt(left) })
      : (inCart ? T.doneCart : T.doneThis);
    setText(el.shipMsg, msg);
    var w = Math.max(4, Math.min(100, Math.round(projected / FREE * 100))) + '%';
    if (el.shipBar.style.width !== w) el.shipBar.style.width = w;
    var done = left <= 0;
    if (el.ship.classList.contains('is-done') !== done) el.ship.classList.toggle('is-done', done);
  }

  /* ---------- "Tedd mellé" (12. csapda) ---------- */
  var xs = [];
  try { xs = JSON.parse(root.querySelector('.xpdp-xs-data').textContent) || []; } catch (e) {}
  if (!xs.length && el.xsHead) el.xsHead.hidden = true;
  // A képek NEM lazy-k: mobilon a vízszintes görgetősávban nem töltöttek be (mérve).
  xs.slice(0, 3).forEach(function (p) {
    var card = document.createElement('div');
    card.className = 'xpdp-xs-card';
    card.innerHTML = '<span class="xpdp-xs-price"></span><a class="xpdp-xs-img"></a>' +
                     '<a class="xpdp-xs-name"></a><span class="xpdp-xs-var"></span>' +
                     '<button type="button" class="xpdp-xs-add"></button>';
    card.querySelector('.xpdp-xs-price').textContent = '+ ' + eurFmt(p.price);
    var ia = card.querySelector('.xpdp-xs-img'); ia.href = p.url;
    if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = p.title; im.width = 120; im.height = 120; ia.appendChild(im); }
    var na = card.querySelector('.xpdp-xs-name'); na.href = p.url; na.textContent = p.title;
    var vv = card.querySelector('.xpdp-xs-var');
    if (p.vtitle) vv.textContent = p.vtitle; else vv.remove();
    var btn = card.querySelector('.xpdp-xs-add'); btn.textContent = T.xsAdd;
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.classList.contains('is-added')) return;
      btn.disabled = true;
      fetch((root.dataset.cartadd || '/cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: p.vid, quantity: 1 }], sections: 'cart-icon-bubble' })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (res) {
          btn.disabled = false; btn.classList.add('is-added'); btn.textContent = T.xsAdded;
          var html = res.sections && res.sections['cart-icon-bubble'];
          var bubble = document.getElementById('cart-icon-bubble');
          if (html && bubble) {
            var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            if (sec) bubble.innerHTML = sec.innerHTML;
          }
          if (window.publish && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'xpdp-xs' });
          refreshCart();
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = T.xsErr;
          setTimeout(function () { btn.textContent = T.xsAdd; }, 2500);
        });
    });
    el.xs.appendChild(card);
  });

  /* ---------- mobil ragadós sáv ---------- */
  if (el.stickyBtn) {
    el.stickyBtn.addEventListener('click', function () {
      var a = realAtc();
      if (a && !a.disabled) a.click();
    });
  }
  var io = null, ioTarget = null;
  function watchAtc() {
    var a = realAtc();
    if (!a || !el.sticky) return;
    if (el.sticky.hidden) el.sticky.hidden = false;
    if (el.stickyBtn.disabled !== !!a.disabled) el.stickyBtn.disabled = !!a.disabled;
    if (ioTarget === a) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (el.sticky.classList.contains('is-on') !== on) el.sticky.classList.toggle('is-on', on);
      });
    });
    io.observe(a);
    ioTarget = a;
  }

  /* ---------- indulás + újraépítés ---------- */
  function boot() {
    if (!place()) return;
    renderGrid();
    paintPrice();
    watchAtc();
  }
  boot();
  refreshCart();

  var pending = null;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(boot, 60);
  }).observe(document.querySelector('.product') || document.body, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('select__select')) {
      setTimeout(function () { sync(); paintPrice(); watchAtc(); }, 60);
    }
  }, true);

  // A Dawn constants.js/pubsub.js DEFER-rel töltődik, és a PUB_SUB_EVENTS `const`
  // (nincs a window-on). Ezért typeof, és csak DOMContentLoaded után.
  function hookCart() {
    if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCart, 150); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hookCart); else hookCart();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
})();
